import {RootState} from "./store";

export const getAccountSlice = (state: RootState) => state.account

export const getHulabillSlice = (state: RootState) => state.hulabill

export const getStepperSlice = (state: RootState) => state.stepper

export const getNavSlice = (state: RootState) => state.nav